import { useCallback } from 'react'
import { ScrollTrigger } from '../utils/gsap'
import {
  BOARD_SCRUB,
  BOARD_VIDEO_PIN_VH,
  computeHighlightZoomValues,
  getBoardPinStart,
  getHighlightMaskTarget,
  getPinScrollDistance,
} from '../utils/scrollAnimation'
import { HIGHLIGHT_INITIAL_MASK_SIZE } from '../components/home/highlightVideoLayout'
import { useGsapScroll } from './useGsapScroll'

export function useHighlightScrollZoom(
  trackRef,
  pinRef,
  layerRefs,
  getMetrics,
  videoRef,
  enabled,
) {
  const setup = useCallback(() => {
    const track = trackRef.current
    const pin = pinRef.current
    const layers = layerRefs.current
    if (!track || !pin) return

    ScrollTrigger.create({
      trigger: track,
      start: getBoardPinStart(0),
      end: () => `+=${getPinScrollDistance(BOARD_VIDEO_PIN_VH)}`,
      pin,
      pinSpacing: true,
      scrub: BOARD_SCRUB,
      invalidateOnRefresh: true,
      anticipatePin: 1,
      preventOverlaps: true,
      onUpdate: (self) => {
        const metrics = getMetrics?.() ?? { layoutScale: 1 }
        const layoutScale = metrics.layoutScale > 0 ? metrics.layoutScale : 1
        const initialMaskSize = HIGHLIGHT_INITIAL_MASK_SIZE
        const targetMaskSize = getHighlightMaskTarget(layoutScale)
        const values = computeHighlightZoomValues(self.progress, initialMaskSize, targetMaskSize)
        const maskSizePx = `${values.maskSize}px`

        if (layers.videoMask) {
          layers.videoMask.style.webkitMaskSize = maskSizePx
          layers.videoMask.style.maskSize = maskSizePx
        }

        const video = videoRef?.current
        if (video && video.paused && Number.isFinite(video.duration) && video.duration > 0) {
          video.currentTime = self.progress * video.duration
        }
      },
    })
  }, [trackRef, pinRef, layerRefs, getMetrics, videoRef])

  useGsapScroll(trackRef, enabled, setup)
}
